export default function InterventionsGrid() {
  const interventions = [
    {
      href: "/reglage-fenetre-oscillo-battant",
      title: "Réglage oscillo-battant",
      desc: "Fenêtre qui frotte ou déraille dans votre maison à Obernai ? Réglage précis des ciseaux et galets en une visite.",
      icon: "ri-arrow-up-down-line",
    },
    {
      href: "/cremone-fenetre",
      title: "Crémone cassée",
      desc: "Mécanisme de verrouillage bloqué à Obernai ? Remplacement de la crémone, des maisons à colombages aux immeubles modernes.",
      icon: "ri-lock-line",
    },
    {
      href: "/poignee-fenetre-bloquee",
      title: "Poignée bloquée",
      desc: "Poignée cassée ou qui tourne dans le vide à Obernai ? Changement rapide avec pièces adaptées, toutes marques.",
      icon: "ri-hand-coin-line",
    },
    {
      href: "/gond-paumelle-fenetre",
      title: "Gond et paumelle",
      desc: "Fenêtre qui s'affaisse ou frotte à Obernai ? Réglage des gonds et remplacement des paumelles usées.",
      icon: "ri-hammer-line",
    },
    {
      href: "/fenetre-ferme-mal",
      title: "Fenêtre qui ferme mal",
      desc: "Infiltrations d'air ou fermeture difficile à Obernai ? Réparation des joints et réglage du serrage de votre fenêtre.",
      icon: "ri-door-closed-line",
    },
    {
      href: "/fenetre-oscillo-battant-bloquee",
      title: "Fenêtre bloquée",
      desc: "Fenêtre bloquée en position oscillo ou battant à Obernai ? Dépannage rapide et réparation complète du mécanisme.",
      icon: "ri-lock-unlock-line",
    },
  ];

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-4 md:mb-6">
            Nos interventions à Obernai
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8 md:mb-10">
            Au cœur du vignoble alsacien, nous réparons toutes les fenêtres à Obernai : du centre historique aux quartiers résidentiels. Intervention rapide, pièces de rechange sur place.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {interventions.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="group bg-white rounded-2xl p-5 md:p-6 border border-rose-100 hover:border-coral/30 transition-colors"
            >
              <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center mb-4 group-hover:bg-coral/10 transition-colors">
                <i className={`${item.icon} text-plum text-xl group-hover:text-coral transition-colors`} />
              </div>
              <h3 className="font-semibold text-base md:text-lg text-plum-dark mb-2 group-hover:text-coral transition-colors">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-plum-dark/70 leading-relaxed">
                {item.desc}
              </p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-coral mt-3">
                En savoir plus
                <i className="ri-arrow-right-line" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}